var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11.1351C1 10.6069 1.42825 10.1786 1.95652 10.1786H3.86957C4.39784 10.1786 4.82609 10.6069 4.82609 11.1351C4.82609 11.6634 4.39784 12.0917 3.86957 12.0917H1.95652C1.42825 12.0917 1 11.6634 1 11.1351Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5652 11.1351C10.5652 10.6069 10.9935 10.1786 11.5217 10.1786H22.0435C22.5717 10.1786 23 10.6069 23 11.1351C23 11.6634 22.5717 12.0917 22.0435 12.0917H11.5217C10.9935 12.0917 10.5652 11.6634 10.5652 11.1351Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.86963 7.21727C3.86963 6.689 4.29788 6.26075 4.82615 6.26075H10.5653C11.0936 6.26075 11.5218 6.689 11.5218 7.21727V15.0566C11.5218 15.3922 11.3459 15.7033 11.0583 15.8763L8.18876 17.6024C7.88539 17.7849 7.50604 17.7849 7.20267 17.6024L4.3331 15.8763C4.04552 15.7033 3.86963 15.3922 3.86963 15.0566V7.21727ZM5.78267 8.1738V14.5157L7.69572 15.6665L9.60876 14.5157V8.1738H5.78267Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider);
export default __webpack_public_path__ + "static/media/slider.c450255d75bbd295624ad8a3e638d736.svg";
export { ForwardRef as ReactComponent };